export enum TransactionSearchRequestContextActions {
  setFormData,
  clearAll,
}
